module.exports = __webpack_public_path__ + "img/cases-brand-maxam-9.7ca2da66.jpg";